const colors = require('../../../server/utils/EmployeeWorkforceColorMath');
const {normalizeContrast, normalizeTargetColor, colorPresentation, contrastRatio} = colors;
const CONTRAST_STORAGE_KEY = 'employee-workforce:plan-contrast:v1';
const DEFAULT_ZOOM = 90;
const STATE_COLORS = {
    object: ['#dff1e5', '#21653d'],
    object_group: ['#e8f3ce', '#557814'],
    planned_object: ['#e6f5eb', '#17603f'],
    requires_distribution: ['#ffffff', '#9f2922'],
    rest: ['#e2e2e2', '#4b4b4b'],
    loupe: ['#fff0c7', '#86610b']
};
function normalizeZoom(value) {
    const number = Number(value);
    return Number.isFinite(number) ? Math.round(Math.min(125, Math.max(50, number)) / 5) * 5 : DEFAULT_ZOOM;
}

function weekWidth(zoom, mobile) {
    const stops = [50, 75, 90, 100, 125];
    const widths = mobile ? [36, 40, 44, 48, 56] : [24, 30, 34, 38, 46];
    const value = normalizeZoom(zoom);
    const index = stops.findIndex(stop => stop >= value);
    if (index === 0) return widths[0];
    return Math.round(widths[index - 1] + (widths[index] - widths[index - 1])
        * (value - stops[index - 1]) / (stops[index] - stops[index - 1]));
}

function readLocal(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
}

function writeLocal(key, value) {
    try { window.localStorage.setItem(key, String(value)); } catch (error) { /* Session value still works. */ }
}

function readContrast() {
    const value = Number(readLocal(CONTRAST_STORAGE_KEY));
    return Number.isFinite(value) && value >= 0 && value <= 100 ? normalizeContrast(value) : 0;
}
function writeContrast(value) { writeLocal(CONTRAST_STORAGE_KEY, normalizeContrast(value)); }
function contrastHintKey(user) {
    const current = user || {};
    return `employee-workforce:plan-contrast-hint:v1:${current.company || 'company'}:${current.userId || current.user_id || 'anonymous'}`;
}

module.exports = {CONTRAST_STORAGE_KEY, DEFAULT_ZOOM, STATE_COLORS, normalizeContrast, normalizeZoom,
    weekWidth, readContrast, writeContrast, readLocal, writeLocal, contrastHintKey, colorPresentation, contrastRatio,
    normalizeTargetColor, isTargetColor: colors.isTargetColor, TARGET_PALETTE: colors.PALETTE,
    MANUAL_TARGET_PALETTE: colors.MANUAL_PALETTE, TARGET_COLOR_TEXT: colors.COLOR_TEXT};
